import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, } from '@airia/ui';
import { ChevronDown } from 'lucide-react';
import { useAddinChatActions } from '../AddinChatActionsContext';
import { MessageDropdownSchema, parseDropdownOptions } from './schemas';
/**
 * Renders `<airiaMessageDropdown>` as a single-select dropdown menu. Each
 * menu item submits its `message` immediately on click — no separate Send
 * step (use `<airiaMessageRadios>` for that pattern).
 */
export function MessageDropdown(props) {
    const { children, artifactContent, buttonText, isLoading } = MessageDropdownSchema.parse(props);
    const actions = useAddinChatActions();
    const optionsSource = artifactContent || children;
    const options = parseDropdownOptions(optionsSource);
    if (options.length === 0)
        return null;
    const disabled = !actions || actions.isExecuting || isLoading;
    const triggerLabel = buttonText.length > 0 ? buttonText : 'Choose an option';
    return (_jsxs(DropdownMenu, { modal: false, children: [_jsx(DropdownMenuTrigger, { asChild: true, children: _jsxs(Button, { size: "sm", variant: "outline", disabled: disabled, children: [triggerLabel, _jsx(ChevronDown, { className: "ms-1 h-4 w-4", "aria-hidden": "true" })] }) }), _jsx(DropdownMenuContent, { align: "start", children: options.map((option, index) => (_jsx(DropdownMenuItem, { onSelect: () => {
                        if (!actions)
                            return;
                        void actions.submitMessage(option.message);
                    }, children: option.label }, index))) })] }));
}
